// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/detail/long_description.scss
// module id = 94
// module chunks = 0